import React, { useEffect, useState } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Form, Image } from 'antd';

import { FILE_STATUS } from 'common/constants.files';
import Select from 'components/lib/Select';

import { PHOTOS_CATEGORIES } from './constants';
import DownCaretIcon from '../../../../../common/Icons/DownCaretIcon';
import Loader from '../../../../lib/Loader';
import {
  RemoveIconContainer,
  ThumbnailContainer,
  ThumbnailLoader,
} from '../../../../ShopData/documents/ShopDataModalThumbnail';

const PhotoUploadThumbnail = (originNode: any, file: any, fileList: any, actions: any, disabled?: boolean) => {
  const fileUploading = file.status !== FILE_STATUS.DONE;
  const [previewUrl, setPreviewUrl] = useState(file.mock ? file.url : '');

  useEffect(() => {
    if (file.mock) {
      setPreviewUrl(file.url ?? '');
      return;
    }

    const originFile = file?.originFileObj;
    if (!(originFile instanceof Blob) || typeof URL?.createObjectURL !== 'function') {
      setPreviewUrl('');
      return;
    }

    let objectUrl = '';

    try {
      objectUrl = URL.createObjectURL(originFile);
      setPreviewUrl(objectUrl);
    } catch (error) {
      setPreviewUrl(file.url ?? file.thumbUrl ?? '');
      return;
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file.mock, file.originFileObj, file.thumbUrl, file.url]);

  const onRemove = () => {
    if (!disabled) {
      actions.remove();
    }
  };

  return (
    <div>
      <ThumbnailContainer>
        {fileUploading && <ThumbnailLoader />}
        {!fileUploading && (
          <>
            <Image
              src={previewUrl}
              width={134}
              height={134}
              style={{ objectFit: 'cover', cursor: disabled ? 'not-allowed' : 'pointer' }}
              alt={file.name}
              fallback={'/no-image.png'}
            />
            <RemoveIconContainer onClick={onRemove}>
              <CloseOutlined style={{ color: 'var(--white)', fontSize: 12 }} />
            </RemoveIconContainer>
          </>
        )}
      </ThumbnailContainer>
      <Form.Item
        name={['photos', fileList.indexOf(file), 'category']} // Ensure the category is stored per file
        rules={[{ required: true, message: 'Please select a category' }]}
      >
        <Select
          placeholder="Select"
          className="rectangular"
          style={{ width: '134px', marginTop: 10, height: 36 }}
          options={PHOTOS_CATEGORIES}
          suffixIcon={<DownCaretIcon />}
          dropdownStyle={{
            padding: 0,
            borderRadius: 0,
            border: '1px solid var(--line-gray)',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
          }}
        />
      </Form.Item>
    </div>
  );
};

export default PhotoUploadThumbnail;
